import React, { Component, Fragment } from "react";
import postService from "../../services/postService";
import CircularLoadingScreen from "../commons/CircularLoadingScreen";
import { formatDistance, format } from "date-fns";
import NewReply from "./NewReply";
import Reply from "./Reply";
import SentimentDissatisfiedIcon from "@mui/icons-material/SentimentDissatisfied";
import { Link } from "react-router-dom";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import { ClickAwayListener } from "@mui/base";
import { styled } from "@mui/material/styles";
import { IconButton } from "@mui/material";
import LinkIcon from "@mui/icons-material/Link";
import { Button } from "@mui/material";
import Share from "./../commons/Share";
import { withSnackbar } from "./../../hocs/withSnackbar";
import CodeIcon from "@mui/icons-material/Code";
import BookmarkBorderOutlinedIcon from "@mui/icons-material/BookmarkBorderOutlined";
import BookmarkIcon from "@mui/icons-material/Bookmark";
import CopyToClipboard from "react-copy-to-clipboard";

import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import DeleteIcon from "@mui/icons-material/Delete";
import LoadingButton from "@mui/lab/LoadingButton";
import userService from "../../services/userService";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";

import { withRouter } from "react-router-dom";
import NotFound from "./../NotFound";
import Username from "./Username";

import ThumbUpIcon from "@mui/icons-material/ThumbUp";
import ThumbUpAltOutlinedIcon from "@mui/icons-material/ThumbUpAltOutlined";

const HtmlTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "white",
    color: "black",
    fontSize: 15,
    width: 200,
    fontFamily: "inherit",
    padding: 0,
    boxShadow: "0px 8px 16px 0px rgb(0 0 0 / 20%)",
  },
}));

class PostAndReplies extends Component {
  state = {
    loadedPost: false,
    postExists: true,
    post: {},
    loadedReplies: false,
    replies: [],
    showOptionsTooltip: false,
    showDeleteConfirmationDialog: false,
    deleteLoading: false,
  };

  async componentDidMount() {
    await this.loadReview();
    await this.loadReplies();
  }

  getPostDate(creationDate) {
    const now = Date.now();
    return formatDistance(new Date(creationDate), now, {
      addSuffix: true,
    });
  }

  loadReview = async () => {
    try {
      const { id } = this.props.match.params;
      const response = await postService.getPost(id);
      const post = response.data.data;
      this.setState({
        loadedPost: true,
        post,
      });
    } catch (error) {
      if (error.response && error.response.status == 404) {
        this.setState({
          postExists: false,
        });
      }
    }
  };

  loadReplies = async () => {
    const { id } = this.props.match.params;
    const response = await postService.getPostReplies(id);
    const replies = response.data.data;
    this.setState({
      loadedReplies: true,
      replies,
    });
  };

  toggleBookmark = async () => {
    try {
      const { post } = this.state;
      const response = await postService.bookmark(post.id);
      const state = response.data.data;
      if (state) {
        this.props.showMessage("Bookmarked post");
      } else {
        this.props.showMessage("Unbookmarked post");
      }
      const statePost = { ...this.state.post };
      statePost.bookmarked = state;
      this.setState({
        post: statePost,
      });
    } catch (err) {
      if (err?.response?.data?.message) {
        this.props.showMessage(err.response.data.message, "error");
      } else {
        this.props.showMessage(
          "Failed to toggle bookmark: an error occurred",
          "error"
        );
      }
    }
  };

  toggleLike = async (e) => {
    try {
      const { post } = this.state;
      const response = await postService.like(post.id);
      if (response.data.data.success) {
        this.props.showMessage("Liked post");
      } else {
        this.props.showMessage("Unliked post");
      }
      const statePost = { ...this.state.post };
      const { state, score } = response.data.data;
      statePost.liked = state;
      statePost.score = score;
      this.setState({
        post: statePost,
      });
    } catch (err) {
      if (err?.response?.data?.message) {
        this.props.showMessage(err.response.data.message, "error");
      } else {
        this.props.showMessage(
          "Failed to toggle like: an error occurred",
          "error"
        );
      }
    }
  };

  deletePost = async () => {
    try {
      this.setState({
        deleteLoading: true,
      });
      const { post } = this.state;
      const response = await postService.deletePost(post.id);
      this.setState({
        deleteLoading: false,
        showDeleteConfirmationDialog: false,
      });
      this.props.history.push("/");
    } catch (err) {
      this.setState({
        deleteLoading: false,
        showDeleteConfirmationDialog: false,
      });
      if (err?.response?.data?.message) {
        this.props.showMessage(err.response.data.message, "error");
      } else {
        this.props.showMessage(
          "Failed to delete post: an error occurred",
          "error"
        );
      }
    }
  };

  render() {
    const {
      loadedPost,
      post,
      loadedReplies,
      replies,
      showOptionsTooltip,
      showDeleteConfirmationDialog,
      deleteLoading,
      postExists,
    } = this.state;
    const { author, category } = post;
    const categoryHashtag = category?.name?.replaceAll("&", "and");
    const hashtags = ["oumedia", categoryHashtag];

    const backendApiPath = process.env.REACT_APP_BACKEND_API_PATH;
    const appUrl = process.env.REACT_APP_URL;
    const { id } = this.props.match.params;
    const postUrl = appUrl + "/post/" + id;

    const currentUser = userService.getCurrentUser();
    const postLines = loadedPost ? post.body.split("\n") : null;

    const { history } = this.props;

    if (!postExists) {
      return <NotFound />;
    }

    return (
      <Fragment>
        {!loadedPost ? (
          <CircularLoadingScreen thickness={5} />
        ) : (
          <Fragment>
            <div
              className="post nohover"
              style={{
                paddingTop: 15,
                cursor: "default",
                position: "relative",
              }}
            >
              <div style={{ display: "flex" }}>
                <div className="post-profile-pic">
                  <div className="pic-container" style={{ margin: 0 }}>
                    <img
                      src={backendApiPath + `/profile/${author.username}/pic`}
                      height="40"
                      width="40"
                    />
                  </div>
                </div>
                <div
                  className="post-metadata"
                  style={{ flexDirection: "column", marginLeft: 15 }}
                >
                  <Username
                    username={post.author.username}
                    onClick={(e) => {
                      e.preventDefault();
                      history.push(`/profile/${post.author.username}`);
                    }}
                  />
                  <div className="post-date">
                    {this.getPostDate(post.createDate)} ·{" "}
                    {format(
                      new Date(post.createDate),
                      "hh:mm aa, MMM dd, yyyy"
                    )}
                  </div>
                </div>
              </div>
              <div className="post-data">
                <ClickAwayListener
                  onClickAway={() =>
                    this.setState({
                      showOptionsTooltip: false,
                    })
                  }
                >
                  <div className="post-options-toggle">
                    <HtmlTooltip
                      placement="left"
                      PopperProps={{
                        disablePortal: true,
                      }}
                      title={
                        <div className="post-options-popup">
                          <CopyToClipboard
                            text={postUrl}
                            onCopy={() => {
                              this.props.showMessage(
                                "Copied post URL to clipboard"
                              );
                              this.setState({
                                showOptionsTooltip: false,
                              });
                            }}
                          >
                            <Button startIcon={<LinkIcon />} fullWidth>
                              Copy post link
                            </Button>
                          </CopyToClipboard>
                          <Button
                            startIcon={
                              post.liked ? (
                                <ThumbUpIcon />
                              ) : (
                                <ThumbUpAltOutlinedIcon />
                              )
                            }
                            fullWidth
                            onClick={() => {
                              this.toggleLike();
                              this.setState({
                                showOptionsTooltip: false,
                              });
                            }}
                          >
                            {post.liked ? "Unlike" : "Like"}
                          </Button>
                          <Button
                            startIcon={
                              post.bookmarked ? (
                                <BookmarkIcon />
                              ) : (
                                <BookmarkBorderOutlinedIcon />
                              )
                            }
                            fullWidth
                            onClick={() => {
                              this.toggleBookmark();
                              this.setState({
                                showOptionsTooltip: false,
                              });
                            }}
                          >
                            {post.bookmarked ? "Unbookmark" : "Bookmark"}
                          </Button>
                          <CopyToClipboard
                            text={`<iframe height="200"scrolling="no"src="${appUrl}/embed/${post.id}"style="border:1px solid #dedede;border-radius:5px"width="500"></iframe>`}
                            onCopy={() => {
                              this.props.showMessage(
                                "Copied embed code. You can now use this in your HTML page.",
                                "success",
                                10000
                              );
                              this.setState({
                                showOptionsTooltip: false,
                              });
                            }}
                          >
                            <Button startIcon={<CodeIcon />} fullWidth>
                              Embed post
                            </Button>
                          </CopyToClipboard>
                          {(post.author.username == currentUser.sub ||
                            currentUser.isAdmin) && (
                            <div className="post-action">
                              <Button
                                className="icon"
                                onClick={(e) => {
                                  e.preventDefault();
                                  this.setState({
                                    showDeleteConfirmationDialog: true,
                                    showOptionsTooltip: false,
                                  });
                                }}
                                startIcon={<DeleteOutlineIcon />}
                                fullWidth
                              >
                                Delete
                              </Button>
                            </div>
                          )}
                          <div style={{ borderTop: "1px solid #dedede" }}>
                            <Share
                              title={post.title}
                              url={postUrl}
                              hashtags={hashtags}
                            />
                          </div>
                        </div>
                      }
                      onClose={() =>
                        this.setState({
                          showOptionsTooltip: false,
                        })
                      }
                      open={showOptionsTooltip}
                      disableFocusListener
                      disableHoverListener
                      disableTouchListener
                    >
                      <IconButton
                        onClick={(e) => {
                          e.preventDefault();
                          this.setState({
                            showOptionsTooltip: true,
                          });
                        }}
                      >
                        <MoreVertIcon className="icon" />
                      </IconButton>
                    </HtmlTooltip>
                  </div>
                </ClickAwayListener>
                <div
                  className="post-content"
                  style={{
                    cursor: "auto",
                  }}
                >
                  <h3
                    className="heading post-heading"
                    style={{ fontSize: 30, marginBottom: 10 }}
                  >
                    {post.title}
                  </h3>
                  <div className="post-body" style={{ fontSize: 20 }}>
                    {postLines.map((line, i) => (
                      <p
                        key={i}
                        style={{
                          marginTop: i == 0 ? 0 : "unset",
                          marginBottom: i == postLines.length - 1 ? 0 : "unset",
                        }}
                      >
                        {line}
                      </p>
                    ))}
                  </div>
                </div>
              </div>
              <div className="post-stats">
                <div className="post-stat">
                  <b>{post.numOfReplies}</b>{" "}
                  <span className="post-stat-label">{post.numOfReplies == 1 ? "reply" : "replies"}</span>
                </div>
                <div className="post-stat">
                  <b>{post.score}</b>{" "}
                  <span className="post-stat-label">
                    like{post.score != 1 && "s"}
                  </span>
                </div>
                <div className="post-stat">
                  {post.category?.name ? (
                    <Fragment>
                      <b>{post.category?.name}</b>{" "}
                      <span className="post-stat-label">category</span>
                    </Fragment>
                  ) : (
                    <span className="post-stat-label">No category</span>
                  )}
                </div>
              </div>
            </div>
          </Fragment>
        )}
        <div className="replies">
          {!loadedReplies ? (
            <CircularLoadingScreen thickness={5} />
          ) : (
            <Fragment>
              <NewReply postId={id} onNewReply={this.loadReplies} />
              {replies.length > 0 ? (
                <Fragment>
                  {replies.map((reply) => (
                    <Reply
                      reply={reply}
                      key={reply.id}
                      onDelete={() => {
                        this.props.showMessage("Deleted reply");
                        this.loadReplies();
                      }}
                    />
                  ))}
                </Fragment>
              ) : (
                <div
                  style={{
                    color: "grey",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    marginTop: 20,
                  }}
                >
                  No replies yet
                  <SentimentDissatisfiedIcon style={{ marginLeft: 10 }} />
                </div>
              )}
            </Fragment>
          )}
        </div>
        <Dialog
          open={showDeleteConfirmationDialog}
          onClose={() => {
            this.setState({
              showDeleteConfirmationDialog: false,
            });
          }}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle
            id="alert-dialog-title"
            sx={{
              fontFamily: "inherit",
            }}
          >
            {"Confirm post deletion"}
          </DialogTitle>
          <DialogContent>
            <DialogContentText
              id="alert-dialog-description"
              sx={{
                fontFamily: "inherit",
              }}
            >
              Are you sure you want to delete your post? This action cannot be
              undone.
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              variant="outlined"
              onClick={(e) => {
                this.setState({
                  showDeleteConfirmationDialog: false,
                });
              }}
            >
              Cancel
            </Button>
            <LoadingButton
              onClick={this.deletePost}
              loading={deleteLoading}
              loadingPosition="start"
              startIcon={<DeleteIcon />}
              autoFocus
              variant="contained"
              color="error"
            >
              Delete
            </LoadingButton>
          </DialogActions>
        </Dialog>
      </Fragment>
    );
  }
}

export default withRouter(withSnackbar(PostAndReplies));
